<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="illustype_image_text"><div class="caption"><div class="p-c"><span><strong class="b">Shiloh, April 6, 1862</strong></span></div></div>
<div class="image_text"><img alt="e9781429968911_i0022.jpg" src="e9781429968911_i0022.jpg"/></div></div>
<div class="illustype_image_text"><div class="caption"><div class="p-c"><span><strong class="b">Shiloh, April 7, 1862</strong></span></div></div>
<div class="image_text"><img alt="e9781429968911_i0023.jpg" src="e9781429968911_i0023.jpg"/></div></div>
<div class="illustype_fullpage_image_text"><div class="caption"><div class="p-c"><span><strong class="b">Siege of Vicksburg, May 18–July 4, 1863</strong></span></div></div>
<div class="fullpage_image_text"><img alt="e9781429968911_i0024.jpg" src="e9781429968911_i0024.jpg"/></div>
</div>
<div class="illustype_image_text"><div class="caption"><div class="p-c"><span><strong class="b">Battles at Chattanooga, November 23-25, 1863</strong></span></div></div>
<div class="image_text"><img alt="e9781429968911_i0025.jpg" src="e9781429968911_i0025.jpg"/></div>
</div>
<div class="illustype_image_text"><div class="caption"><div class="p-c"><span><strong class="b">Grant Battles Lee in Virginia, 1864-1865</strong></span></div></div>
<div class="image_text"><img alt="e9781429968911_i0026.jpg" src="e9781429968911_i0026.jpg"/></div>
</div>
<div class="illustype_fullpage_image_text"><div class="caption"><div class="p-c"><span><strong class="b">Sherman’s Marches, 1864-1865</strong></span></div></div>
<div class="fullpage_image_text"><img alt="e9781429968911_i0027.jpg" src="e9781429968911_i0027.jpg"/></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429968911_fm02.vue?5f3bcb10